import { useState, useEffect } from 'react';

/**
 * Hook to detect if the screen is mobile based on a breakpoint
 * @param {number} breakpoint - The width breakpoint in pixels
 * @returns {boolean} - Whether the screen is mobile
 */
const useResponsive = (breakpoint = 922) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window?.innerWidth < breakpoint);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window?.addEventListener?.('resize', checkIfMobile);
    
    // Cleanup
    return () => {
      window?.removeEventListener?.('resize', checkIfMobile);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useResponsive;